import { placeMap, pointMap } from '@/api';
import { post } from '@/common/request';
import { Group, Label, PlaceInfo } from './place';
import { RoleInfo } from './roleSet';

export interface SearchParams {
  placeName?: string;
  placeCategoryIdList?: number[],
  placeLabelIdList?: number[],
  spotName?: string;
  spotCode?: number;
  spotCategoryIdList?: number[],
  role?: {
    roleId?: number,
    employeeIdList?: number[]
  },
  indoorOrOutdoor?: number,
  spotAreaRange?: Range;
  publishPrice?: Range;
  onShelvesStatus?: number,
  reviewStatus?: number,
  editStatus?:number,
  isInReview?: number,
  spotLabelIdList?: number[]
}


export interface SpotInfo {
  address?: any;
  independentSpot?: number;
  tenantSpotId?: number;
  spotCode?: number;
  spotName?: string;
  spotLW?: string;
  weekdayPrice?: string,
  weekdayFlow?: string;
  spotDescription?: string;
  spotCategoryId?: number;
  spotCategoryName?: number;
  onShelvesStatus?: number;
  reviewStatus?: number;
  editStatus?:number;
  onlineDate?: string;
  onlineEmployeeId?: number;
  onlineEmployeeName?: number;
  offlineReason?: string;
  offlineEmployeeId?: number;
  offlineEmployeeName?: string;
  placeRoleRelationList?: number[];
  indoorOrOutdoor?: {
    selectedId?: number;
    name?: string;
    input?:string
  };
  spotArea?: string;
  publishPrice?: number;
  spotFloor?: string;
  tenantPlaceId?: number;
  placeName?: string;
  placeCategoryId?: number;
  placeCategoryName?: string;
  spotLabelList?: Label[];
  workdayDayAvg?: number;
  spotPanorama?: File[]
  spotPicture?: File[]
  spotVideo?: File[]
  floorPlan?: File[]
  topPropertyList?: any[];
  spotPublicId?: number
}

export interface CreateInfo {
  placeName: string;
  placeCategoryId: number,
  area: {
    provinceId: number,
    cityId: number,
    districtId: number
  },
  address: {
    address: string,
    longitude: number,
    latitude: number,
    poiId: number,
    poiName: number
  }
}

interface Respone {
  resourceGroupList?: Group[];
  placeBasicInfo?: PlaceInfo;
  spotBasicInfo?: SpotInfo;
  onShelvesStatus?: number;
  permissions?: any[];
}


export interface DetailInfo extends SpotInfo {
  propertyValueList: PropertyValue[];
  categoryId?: number;
}

export interface PropertyValueEdit {
  propertyId: number;
  textValue?: any;
}

export interface PropertyValue extends PropertyValueEdit {
 categoryPropertyGroupId?: number;
 categoryPropertyGroupConfigId?: number;
 categoryPropertyGroupConfigIdentification?: string;
 controlType?: number;
 propertyValueOptionList?: any[];
}

export interface Config {
  labelValue?: string,
  labelName?: string,
  type?: string,
  suffix?: null,
  optionList?: {
      name?: string,
      value?: string
    }[],
}


interface RoleItem extends RoleInfo {
  employeeList?: {
    employeeId: number,
    employeeName: string,
    mobile: string;
  }[]
}

export interface Price {
  weekdayPrice?: number,
  weekendPrice?: number,
  holidayPrice?: number,
  singleWeekPrice?: number,
  doubleWeekPrice?: number,
  singleNineDayPrice?: number,
  doubleNineDayPrice?: number,
  monthlyPrice?: number,
  fridayPrice?: number,
  deposit?: number,
  approvalFee?: string,
  sundryFee?: string,
  remark?: string,
}

// 图标类型
type ChartsType = 'INVERSION_RATE' | 'TRANSACTION_AMOUNT' | 'CUSTOMER_LEVEL' | 'INDUSTRY'
// 类型 - 合作情况转化率：INVERSION_RATE，成交金额：TRANSACTION_AMOUNT，客户等级：CUSTOMER_LEVEL，客户行业：INDUSTRY

// 合作情况

interface Quote {
  number?: number; // 需求编号
  spotId?: number; // 点位id
  placeId?: number; // 场地id
  enterpriseName?: string; // 客户
  name?: string; // 需求名称
  brandName?: string; //  品牌名称
  product?: string; // 产品
  scheduleList?: any[]; // 档期（按天）
  schedule?: string; // 档期
  price?: string // 报价信息
}

interface Deal {
  orderNum?: number; // 订单号
  spotId?: number; // 点位ID
  placeId?: number; //  场地ID;
  requirementId?: number; // 需求ID
  companyName?: string; // 客户
  name?: string; //  活动名称
  brandName?: string; // brandName
  product?: string; // 产品
  schedule?: string; // 档期
  dealPrice?: number; // 成交价
  }

// 请不要再往这里塞api，用规范写法，不懂就问！
class SpotStore {

  add(info: CreateInfo): Promise<boolean> {
    return post(pointMap.get('add'), info, { needHint: true });
  }

  copyByRes(spotIdList: number[]): Promise<boolean> {
    return post(pointMap.get('copy'), { spotIdList }, { proxyApi: '/resserv', needHint: true });
  }

  getInfoBytenantSpotId(tenantSpotId: number): Promise<DetailInfo> {
    return post(pointMap.get('detail'), { tenantSpotId }, { proxyApi: '/resserv', needHint: true });
  }

  getAnalysisBytenantSpotId(tenantSpotId: number): Promise<Respone> {
    return post(pointMap.get('analysis'), { tenantSpotId }, { proxyApi: '/resserv', needHint: true });
  }


  getSpotEamineOrderDetailBytenantSpotId(tenantSpotId: number): Promise<Respone> {
    return post(pointMap.get('spotEamineOrderDetail'), { tenantSpotId }, { proxyApi: '/resserv', needHint: true });
  }

  // 新增-累计报价
  spotOrderQuoteCreate(params: any): Promise<Respone> {
    return post(pointMap.get('spotOrderQuoteCreate'), params, { proxyApi: '/resserv', needHint: true });
  }

  edit(params): Promise<boolean> {
    return post(pointMap.get('edit'), params, { needHint: true });
  }

  getConfig(): Promise<{conditionList: Config[]}> {
    return post(pointMap.get('config'), {}, { proxyApi: '/resserv', needHint: true });
  }

  deleteRole(tenantSpotId: number, roleId: number, employeeId: number) {
    return post(pointMap.get('deleteRole'), { tenantSpotId, roleId, employeeId }, { proxyApi: '/resserv', needHint: true });
  }

  addRole(tenantSpotId: number, roleId: number, employeeIdList: number[], type: number) {
    return post(pointMap.get('addRole'), { tenantSpotId, roleId, employeeIdList, type }, { proxyApi: '/resserv', needHint: true });
  }

  getPlaceRoleList(tenantPlaceId: number): Promise<RoleItem[]> {
    return post(placeMap.get('roleList'), { tenantPlaceId, type: 0 }, { proxyApi: '/resserv', needHint: true });
  }

  deletePlaceRole(tenantPlaceId: number, roleId: number, employeeId: number) {
    return post(pointMap.get('deleteRole'), { tenantPlaceId, roleId, employeeId, type: 0 }, { proxyApi: '/resserv', needHint: true });
  }

  addPlaceRole(tenantPlaceId: number, roleId: number, employeeIdList: number[], type: number) {
    return post(pointMap.get('addRole'), { tenantPlaceId, roleId, employeeIdList, type }, { proxyApi: '/resserv', needHint: true });
  }



  getSpotPriceDetail(tenantSpotId: number): Promise<Price> {
    return post(pointMap.get('spotPriceDetail'), { tenantSpotId }, { proxyApi: '/resserv', needHint: true });
  }

  getCharts(tntResourceId: number, resourceType: 0 | 1, typeList: ChartsType[]): Promise<any> {
    return post(pointMap.get('charts'), { tntResourceId, resourceType, typeList }, { proxyApi: '/resserv', needHint: true });
  }

  getQuoteList(page: number, size: number, searchParams?: SearchParams): Promise<{objectList: Quote[], page: number, size: number, totalNum:number}> {
    return post(pointMap.get('dwsQuoteList'), { page, size, ...searchParams }, { proxyApi: '/resserv', needHint: true });
  }

  getDealList(page: number, size: number, searchParams?: SearchParams): Promise<{objectList: Deal[], page: number, size: number, totalNum:number}> {
    return post(pointMap.get('dwsDealList'), { page, size, ...searchParams }, { proxyApi: '/resserv', needHint: true });
  }

  getLandedList(page: number, size: number, searchParams?: SearchParams): Promise<{objectList: Deal[], page: number, size: number, totalNum:number}> {
    return post(pointMap.get('dwsLandedList'), { page, size, ...searchParams }, { proxyApi: '/resserv', needHint: true });
  }
}

export default new SpotStore();
